<template>
  <div class="small-logo-wrapper">
    <div class="title-logo" style="height: 35px; display: flex; align-items: center">
      4. 选择模块图标及颜色:
      <el-color-picker
        popper-class="my-color-picker"
        v-model="iconColor"
        size="mini"
      ></el-color-picker>
    </div>
    <div class="small-logo-box">
      <ul class="icon-list">
        <li class="sel-icon" @click="selIcon = item.icon" @mouseenter="hoverId = item.id" @mouseleave="hoverId = null" v-for="item in icons" :key="item.id">
          <icon class="small-sel-icon" :name="item.icon" :size="30" :style="{color: selIcon === item.icon ? iconColor : (hoverId === item.id ? iconColor : '#9f9898')}" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import $pubsub from "../utils/pubsub.js";
import icon from "./icon";
export default {
  name: "m-icon",
  data() {
    return {
      selIcon: null,
      hoverId: null,
      iconColor: "#409EFF",
      icons: []
    };
  },
  components: {
    icon,
  },
  mounted() {
    const store = $pubsub();
    this.icons = store.getter("logos");
  },
  methods: {
    getIcon() {
        return {
            icon: this.selIcon,
            iconColor: this.iconColor
        }
    }
  }
};
</script>

<style lang="scss" scoped>
.small-logo-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;

  .small-logo-box {
    flex: 1;
    max-height: 130px;
    overflow: auto;
    scrollbar-color: #00a4ff transparent;
    scrollbar-width: thin;

    .icon-list {
      width: 100%;
      margin: 0;
      padding: 0;
      display: flex;
      flex-wrap: wrap;
    }

    .sel-icon {
      width: 48px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .small-sel-icon {
        padding: 5px 7px;
        cursor: pointer;
        transition: all 0.3s linear;
      }
    }
  }
}
::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-thumb {
    background: #00a4ff;
    border-radius: 10px;
}
</style>

<style>
.my-color-picker {
    z-index: 10001!important;
}
</style>